import _ from "lodash"

const TableFieldMap = _.merge(
  JSON.parse('{"lineitem":{"__sections":["lineItems","lineItemsExpense","lineItemsExpenseNonRecov","lineItemsMiscIncome","lineItemsBuildingCapital"],"lineitemid":"_id","code":"AccountNumber","name":"Name","type":"LineItemType","reportstatus":"CashFlow","lineitemdetail":["InputType",null],"amt":"Amount","amttype":"AmountType","inflationdetail":["Inflation",null],"areaid":"AreaMeasure","capdetail":["Cap",null],"floordetail":["Floor",null]},"rentroll":{"__sections":["rentRoll"],"rentrollid":"_id","parentrentrollid":"_parentrentrollid","sortorder":"_sortorder","tenant":"Name","suite":"Suite","status":"Status","type":"Type","begindate":"StartDate","enddate":"EndDate","areadetail":"Area","rentdetail":"Rent","freerentdetail":"FreeRent","recoverydetail":["Recovery",null],"miscrevenuedetail":"MiscRevenue","tidetail":"TenantImprovement","lcdetail":"LeasingCommission","othercapitaldetail":"OtherCapital","salesdetail":"PercentageRentSales","breakpointdetail":"PercentageRentBreakpoint","overagedetail":"PercentageRentOverage","renewaltype":"RenewalType","marketleaseid":"MarketLease","overridetype":"OverrideType","overriderent":"OverridesRent","overrideti":"OverridesTenantImprovement","overridelc":"OverridesLeasingCommission","overrideoc":"OverridesOtherCapital","overriderenewalprob":"OverridesRenewalProbability","overridedowntime":"OverridesDowntime","availabledate":["AvailableDate",null],"notedetail":"Notes"},"recovery":{"__sections":["recoveriesNamedRecoveries"],"recoveryid":"_id","name":"Name","code":"Code","recoverydetail":["InputType",null]},"area":{"__sections":["recoveriesAreaMeasures"],"areaid":"_id","name":"Name","code":"Code","amt":"Amount","areadetail":["InputType",null]},"recoverygroup":{"__sections":["recoveriesRecoveryGroups"],"recoverygroupid":"_id","name":"Name","code":"Code","recoverygroupdetail":["InputType",null]},"recoverypool":{"__sections":["recoveriesRecoveryPools"],"recoverypoolid":"_id","name":"Name","code":"Code","recoverypooldetail":["InputType",null]},"reporttag":{"__sections":["recoveriesReportTags"],"reporttagid":"_id","name":"Name","code":"Code","type":"Type"},"tenantcontribution":{"__sections":["recoveriesTenantContributions"],"tenantcontributionid":"_id","name":"Name","code":"Code","tenantgroupdetail":["TenantGroup",null]},"tenantgroup":{"__sections":["recoveriesTenantGroups"],"tenantgroupid":"_id","name":"Name","code":"Code","tenantgroupdetail":["InputType",null]},"increase":{"__sections":["tenantMarketIncrease"],"increaseid":"_id","code":"Code","name":"Name","increasedetail":"InputType","amt":"Increase","amttype":"IncreaseType","inflationdetail":["Inflation",null],"effectivemonth":"Effective"},"rent":{"__sections":["tenantMarketRent"],"rentid":"_id","name":"Name","code":"Code","rentdetail":"InputType","amtnew":"New","amtrenew":"Renewal","amttype":"AmtType","inflationdetail":["Inflation",null]},"freerent":{"__sections":["tenantMarketFreeRent"],"freerentid":"_id","code":"Code","name":"Name","freerentdetail":"InputType","mosnew":"New","mosrenew":"Renewal","amttype":"AmtType","freerentrevtype":"Revenue"},"payout":{"__sections":["tenantMarketPayout"],"payoutid":"_id","name":"Name","code":"Code","payoutdetail":"InputType","mosoffset":"Month"},"tenantcapital":{"__sections":["tenantMarketTI","tenantMarketLC","tenantMarketOC"],"tenantcapitalid":"_id","name":"Name","code":"Code","tenantcapitaldetail":"InputType","amtnew":"New","amtrenew":"Renewal","amttype":"AmtType","inflationdetail":["Inflation",null],"payoutdetail":["Payout",null]},"downtime":{"__sections":["propertyMarketDowntime"],"downtimeid":"_id","name":"Name","code":"Code","downtimedetail":"InputType","mosdowntime":"Downtime"},"inflation":{"__sections":["propertyMarketInflation"],"inflationid":"_id","name":"Name","code":"Code","inflationdetail":"InputType","_effectiveMonth":"EffectiveMonth","amt":"Amt","compoundtype":"Type"},"property":{"__sections":["propertyMarketCreditLoss","propertyMarketVacancyLoss","properties"],"propertyid":"_id","defaultsrentroll":["_defaultsRentRoll",null],"defaultslineitem":["_defaultsLineItem",null],"defaultsnameditem":["_defaultsNamedItem",null],"defaultsmarketlease":["_defaultsMarketLease",null],"defaultsrecovery":["_defaultsRecovery",null],"folderid":"_folder","code":"Code","name":"Name","address1":"_address1","address2":"_address2","city":"_city","state":"_state","status":"Status","postalcode":"_postalCode","analysisbegindate":"AnalysisBegin","reportbegindate":"ReportBegin","term":"Term","errordetail":"_errorDetail","datedetail":["_datedetail",null],"calcdetail":[["_calcDetail"],["LastCalcDate",null]],"activitydetail":[["_activityDetail"],["LastUpdateDate",null],["LastUpdatedBy",null]],"valuationdetail":["_valuationdetail",null],"versiondetail":"_version"},"marketlease":{"__sections":["propertyMarketMarketLease"],"marketleaseid":"_id","code":"Code","name":"Name","termdetail":"Term","downtimedetail":"Downtime","renewaldetail":"RenewalProbability","rentdetail":"Rent","freerentdetail":"FreeRent","recoverydetail":["Recovery",null],"tidetail":"TenantImprovement","lcdetail":"LeasingCommission","othercapitaldetail":"OtherCapital","salesdetail":"PercentageRentSales","breakpointdetail":"PercentageRentBreakpoint","overagedetail":"PercentageRentOverage"},"renewalprobability":{"__sections":["propertyMarketRenewalProbability"],"renewalprobabilityid":"_id","name":"Name","code":"Code","renewalprobabilitydetail":"InputType","percentrenew":"RenewalProbability"},"snapshots":{"__sections":["snapshots"],"snapshotid":"_id","description":"Description","creationtype":"Type","createdate":"CreateDate"},"systemlineitem":{"__sections":["systemLineItems"]}}'),
  { multifamily: {
      attributedetail: 'attributedetail',
      commissiondetail: 'Commission',
      creditlossdetail: 'Credit Loss',
      externalreference: 'externalreference',
      freerentdetail: 'Free Rent',
      makereadydetail: 'Make Ready',
      marketterm: 'Market Term',
      multifamilyid: 'multifamilyid',
      notedetail: 'Notes',
      occupiedrolloverdetail: 'Occupied Rollover',
      organizationid: 'organizationid',
      propertyid: 'propertyid',
      rentdetail: 'Rent',
      sortorder: 'sortorder',
      status: 'status',
      type: 'type',
      unitdescription: 'Unit Description',
      unitenddetail: 'Unit End',
      unitinventorydetail: 'Unit Inventory',
      unitstartdetail: 'Unit Start',
      vacancylossdetail: 'Vacancy Loss',
      vacantleaseupdetail: 'Vacant Lease-Up'
    }
  },{
    room: {
      adrdetail: 'ADR',
      description: 'Description',
      externalreference: 'externalreference',
      notedetail: 'Notes',
      occupancydetail: 'Occupancy',
      organizationid: 'organizationid',
      propertyid: 'propertyid',
      roomdetail: 'Room',
      roomid: 'roomid',
      sortorder: 'sortorder',
      status: 'status',
      type: 'type'
    }
  },{
    portfolioasset: {
      assetid: 'Assets'
    }
  },{
    property: {
      assetid: 'Asset Code'
    }
  }, {
    detailaccount: {
      summaryaccountid: 'Summary Account',
      accountnumber: 'Account Number',
    }
  }, {
    cashflowmap: {
      summaryaccountid: 'Summary Account',
      propertytype: 'Property Type',
    }
  }, {
    summaryaccount: {
      accountnumber: 'Account Number',
      propertytype: 'Property Type',
    }
  }, {
    lineitem: {
      detailaccountid: 'Account Number',
      propertytype: 'Property Type',
    }
  }, {
    asset: {
      assetid: 'assetid',
      organizationid: 'organizationid',
      code: 'Code',
      name: 'Name',
      active: 'Active',
      propertytype: 'Property Type',
      country: 'Country',
      address: 'Address',
      city: 'City',
      state: 'State',
      postalcode: 'Postal Code',
      acquisitiondate: 'Acquisition Date',
      acquisitionamt: 'Acquisition Amount',
      dispositiondate: 'Disposition Date',
      dispositionamt: 'Disposition Amount',
      currency: 'Currency',
      areametric: 'Area Metric',
      ownerpercent: 'Owner Percent',
      yearbuilt: 'Year Built',
      yearrenovated: 'Year Renovated',
      notedetail: 'Notes',
      chartid: 'Chart',
    }
  }, {
    attribute: {
      code: 'Code',
      name: 'Name',
    }
  }, {
    assetattribute: {
      value: 'Value'
    }
  }, {
    portfolio: {
      code: 'Code',
      name: 'Name'
    }
  },
  {
    chart: {
      code: 'Code',
      name: 'Name'
    }
  },
  {
    user: {
      approles: 'Application Access'
    }
  }, {
    usergroup: {
      approles: 'Application Access',
      code: 'Code',
      name: 'Name'
    }
  }
)

export function lookup(table, column, params={}) {
  const section = _.has(TableSectionMap, table)
    ? (_.isFunction(TableSectionMap[table])
      ? TableSectionMap[table](params, column)
      : TableSectionMap[table])
    : _.first(_.get(TableFieldMap, `${table}.__sections`))
  let field = _.get(TableFieldMap, `${table}.${column}`)
  while (_.isArray(field)) field = field[0]
  return {section: _.startCase(section), field: _.startCase(field)}
}

// export function lookupByReducerField(reducer, field) {
//   const exceptions = {
//     rentRoll: { Recovery: 'recoverydetail' },
//     marketLease: { Recovery: 'recoverydetail' },
//     propertyMarketVacancyLoss: { AccountNumber: 'vacancylossaccountnumber', InputType: 'vacancylossdetail' },
//     propertyMarketCreditLoss: { AccountNumber: 'creditlossaccountnumber', InputType: 'creditlossdetail' },
//   }
//   if (reducer.startsWith('lineItems')) reducer = 'lineItems'
//   return _.get(exceptions, [reducer, field]) || config[reducer][1].mapIn.findKey(v => v == field || v[0] == field)
// }

// export function lookupDBTableFromReducer(reducer) {
//   return config[reducer][0]
// }

// export function lookupReducerFromDBTable(table) {
//   for (let reducer in config) {
//     if (config[reducer][0] == table)
//       return reducer
//   }
//   throw new Error(`Can't find reducer for unknown value (${table})`)
// }

/**
 * The above TableFieldMap is based the desire to not create and maintain an additional database
 * name to UI name mapping beyond what already exists in api/handlers-config.  However expedient,
 * greater flexibility will undoubtedly be required.
 */

 const TableSectionMap = {
  area: 'Area Measure',
  asset: 'Asset',
  assetattribute: 'Asset Attributes',
  attribute: 'Attributes',
  chart: 'Chart',
  downtime: 'Downtime',
  folder: 'Folder',
  freerent: 'Free Rent',
  increase: 'Increase',
  inflation: 'Inflation',
  recoverygroup: 'Recovery Group',
  recoverypool: 'Recovery Pool',
  renewalprobability: 'Renewal Probability',
  lineitem: 'Line Item',
  marketlease: 'Market Lease',
  miscrevenue: 'Misc Revenue',
  multifamily: 'Multifamily Rent Roll',
  organization: 'Organization',
  payout: 'Payout',
  porterswage: 'Porterswage',
  portfolio: 'Portfolio',
  portfolioasset: 'Portfolio',
  property: (err_obj, column) => {
    return column == 'valuationdetail' ? 'Valuation Settings'
      : column == 'assetid' ? 'Asset'
      : 'Property'
  },
  recovery: 'Named Recovery',
  rent: 'Rent',
  rentroll: 'Rent Roll',
  reporttag: 'Report Tag',
  room: 'Room',
  tenantcapital: ({type}) => ({ti: 'TI', lc: 'LC', oc: 'Other Capital'}[type]),
  tenantcontribution: 'Tenant Contribution',
  tenantgroup: 'Tenant Group',
  summaryaccount: 'Summary Account',
  detailaccount: 'Detail Account',
  cashflowmap: 'Cash Flow Map',
  user: 'User Settings',
  usergroup: 'User Group Settings'
 }

export const resourceFrom = (url) => {
  const map = {
    '/folder': 'folder',
    '/line-items': 'lineitem',
    '/n/admin/organization-settings': 'organization',
    '/n/hospitality/area-measure': 'area',
    '/n/hospitality/departmental-line-items': 'lineitem',
    '/n/hospitality/inflation': 'inflation',
    '/n/hospitality/line-items': 'lineitem',
    '/n/hospitality/rooms': 'room',
    '/n/line-items/all': 'lineitem',
    '/n/line-items/building-capital': 'lineitem',
    '/n/line-items/expense': 'lineitem',
    '/n/line-items/misc-income': 'lineitem',
    '/n/line-items/non-recoverable-expense': 'lineitem',
    '/n/property-market/downtime': 'downtime',
    '/n/property-market/inflation': 'inflation',
    '/n/property-market/market-lease': 'marketlease',
    '/n/property-market/renewal-probability': 'renewalprobability',
    '/n/property-market/vacancy-credit-loss': 'property',
    '/n/property/area-measure': 'area',
    '/n/property/settings': 'property',
    '/n/property/valuation-settings': 'property',
    '/n/recoveries/area-measure': 'area',
    '/n/recoveries/named-recoveries': 'recovery',
    '/n/recoveries/recovery-groups': 'recoverygroup',
    '/n/recoveries/recovery-pools': 'recoverypool',
    '/n/recoveries/report-tags': 'reporttag',
    '/n/recoveries/tenant-contributions': 'tenantcontribution',
    '/n/recoveries/tenant-groups': 'tenantgroup',
    '/n/rent-roll/home': 'rentroll',
    '/n/rent-roll/market-lease': 'marketlease',
    '/n/rent-roll/named-recoveries': 'recovery',
    '/n/rent-roll/recovery-groups': 'recoverygroup',
    '/n/rent-roll/tenant-groups': 'tenantgroup',
    '/n/tenant-market/free-rent': 'freerent',
    '/n/tenant-market/increase': 'increase',
    '/n/tenant-market/leasing-commissions': 'tenantcapital',
    '/n/tenant-market/other-capital': 'tenantcapital',
    '/n/tenant-market/payout': 'payout',
    '/n/tenant-market/rent': 'rent',
    '/n/tenant-market/tenant-improvement': 'tenantcapital',
    '/property-market': 'inflation',
    '/property': 'property',
    '/property/defaults': 'property',
    '/recoveries': 'recovery',
    '/rent-roll': 'rentroll',
    '/tenant-market': 'rent',
    '/n/asset-management/attributes': 'attribute',
    '/n/asset-management/chart': 'chart',
    '/n/asset-management/chart/\\d/detail-accounts': 'detailaccount',
    '/n/asset-management/chart/\\d/summary-accounts': 'summaryaccount',
    '/n/asset-management/chart/\\d/cash-flow-mapping': 'cashflowmap',
    '/n/asset-management/portfolios': 'portfolio',
    '/n/multifamily/rent-roll': 'multifamily',
    '/n/multifamily/area-measure': 'area',
    '/n/multifamily/inflation': 'inflation',
    '/n/folder/property-list': 'property',
  }

  const resource = map[url] || _.find(map, (v,k) => RegExp(`^${k}$`).test(url))
  if (!resource) {
    console.log('missing url resource mapping for', url)
    debugger
  }
  return resource
}